import throttle from "lodash/throttle";
import { RefObject, useEffect, useRef, useState } from "react";
import { useMediaQuery } from "react-responsive";
import { tablet_desktop } from "src/styles/media";

interface Params {
  scrolledElementRef: RefObject<HTMLDivElement>;
  isModal: boolean;
}

const useFixedHeaderIsVisible = ({ scrolledElementRef, isModal }: Params) => {
  const [isScrolled, setIsScrolled] = useState(false);
  const isTabletDesktop = useMediaQuery({ query: tablet_desktop });
  const fixedHeaderIsVisible = isModal && isTabletDesktop && isScrolled;
  const modalOverlayRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleScroll = throttle(() => {
      if(scrolledElementRef.current) {
        const { bottom } = scrolledElementRef.current.getBoundingClientRect();
        const elementIsScrolled = bottom < 0;
        setIsScrolled(elementIsScrolled);
      }
    }, 200);

    const modalOverlays = document.querySelectorAll<HTMLDivElement>('.GeneralModal__overlay');
    //in editing order several modals can be opened
    modalOverlayRef.current = modalOverlays[modalOverlays.length - 1];
    modalOverlayRef.current?.addEventListener('scroll', handleScroll);

    return () => {
      modalOverlayRef.current?.removeEventListener('scroll', handleScroll);
    };
  }, [scrolledElementRef]);

  return fixedHeaderIsVisible;
};

export default useFixedHeaderIsVisible;
